module.exports = __webpack_public_path__ + "static/media/intprog.34364c7e.svg";